import React from 'react';
import { Box, Typography } from '@mui/material';
import usePageTitle from '../hooks/usePageTitle';

/**
 * Giriş yapmadan açılan sayfaların (giriş, sertifika doğrulama) ortak çerçevesi:
 * üstte marka şeridi, ortada logo ve içerik, altta küçük not.
 */
function PublicShell({ title, footer, children }) {
    usePageTitle(title);

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
            {/* Marka şeridi: kısa kırmızı + lacivert */}
            <Box sx={{ height: 8, display: 'flex' }} aria-hidden="true">
                <Box sx={{ width: 120, bgcolor: 'brand.red' }} />
                <Box sx={{ flexGrow: 1, bgcolor: 'primary.main' }} />
            </Box>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 4,
                    px: 2,
                    py: 6
                }}
            >
                {/* Logo: kartın üstünde, kutusuz */}
                <Box
                    component="img"
                    src="/Logo.png"
                    alt="ARCA Aero"
                    sx={{ width: { xs: 220, sm: 300 }, height: 'auto', display: 'block' }}
                />

                {children}

                {footer && (
                    <Typography variant="body2" sx={{ color: '#6F7A8C', textAlign: 'center' }}>
                        {footer}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}

export default PublicShell;
